export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["选择要约人的账户"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["要约人的账户"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select Account"])}
}